import SectionHeading from './SectionHeading';
import { timelineStages, turningPoints } from '@/mocks/timeline';

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-50 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Storyline"
          title="剧情脉络：从重逢到收束的六个阶段"
          desc="如果你只有几分钟，看完这条时间线就能抓住全剧大致走向；每个阶段下面都给出了对应的关键节点。"
        />

        <ol className="mt-10 relative space-y-6 border-l border-background-300 pl-6 md:space-y-8 md:pl-10">
          {timelineStages.map((item) => (
            <li key={item.stage} className="relative">
              <span className="absolute -left-[34px] flex h-7 w-7 items-center justify-center rounded-full bg-accent-500 text-xs font-bold text-accent-950 md:-left-[54px] md:h-9 md:w-9">
                <i className={`${item.icon} md:text-lg`}></i>
              </span>
              <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-3">
                  <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                    {item.title}
                  </h3>
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 font-label text-xs text-primary-700">
                    {item.time}
                  </span>
                </div>
                <p className="mt-2 text-xs leading-relaxed text-foreground-700 md:text-sm">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-12">
          <h3 className="font-heading text-lg font-semibold text-foreground-950 md:text-xl">四个关键转折点</h3>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {turningPoints.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h4 className="mt-3 font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  {item.title}
                </h4>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}